import { createAutoScrollController } from "./autoScrollController";
import { createDragController } from "./dragController";
import { createLineAlignment } from "./lineAlignment";
import { isDesktopViewport } from "./mediaQueries";
import { createScrollProgressController } from "./scrollProgressController";
import { TIMELINE_FULL_HEIGHT_ATTRIBUTE } from "./constants";

export const mountVerticalTimelineInstance = ({
  element,
  doc,
  win,
  config,
}) => {
  const lineAlignment = createLineAlignment({ element, doc, win });
  // A full height list never scrolls itself, so it behaves as on mobile at every width: progress follows the page.
  const fullHeight = element.hasAttribute(TIMELINE_FULL_HEIGHT_ATTRIBUTE);
  const scrollsInPlace = () => !fullHeight && isDesktopViewport(win);
  const scrollProgressController = createScrollProgressController({
    element,
    win,
    scrollsInPlace,
  });
  const noopController = { destroy: () => {} };
  const noopInteractionController = {
    pauseAndRescheduleAutoScroll: () => {},
    destroy: () => {},
  };
  const autoScrollController = scrollsInPlace()
    ? createAutoScrollController({
        element,
        doc,
        win,
        config,
      })
    : noopInteractionController;
  const dragController = scrollsInPlace()
    ? createDragController({
        element,
        win,
        onInteraction: autoScrollController.pauseAndRescheduleAutoScroll,
      })
    : noopController;

  return () => {
    lineAlignment.destroy();
    dragController.destroy();
    scrollProgressController.destroy();
    autoScrollController.destroy();
  };
};
